import type { SvgIconProps } from "./SVGIcon";
import SvgIcon from "./SVGIcon";

export default function IconPhaseConstruction(props: SvgIconProps) {
  return (
    <SvgIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="6" cy="6" r="6" fill="#47B279" />
      <path d="M3 6L5 8L9 4" stroke="white" strokeWidth="1.5" />
    </SvgIcon>
  );
}
